import Vue from 'vue';
import Router from 'vue-router';

import Landing from '@/app/pages/Landing';
import Explain from '@/app/pages/Explain';
import Game from '@/app/pages/Game';
import Naw from '@/app/pages/Naw';
import Thanks from '@/app/pages/Thanks';

import store from '@/app/store';

Vue.use( Router );

var appRouter = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Landing',
            component: Landing,
            meta: {
                pageType: 'promotion-landing'
            }
        },
        {
            path: '/uitleg',
            name: 'Explain',
            component: Explain,
            meta: {
                pageType: 'promotion-content'
            }
        },
        {
            path: '/game',
            name: 'Game',
            component: Game,
            beforeEnter: ( to, from, next ) =>
            {
                if( !from.name )
                {
                    next( '/' );
                    return;
                }

                next();
            },
            meta: {
                pageType: 'promotion-content'
            }
        },
        {
            path: '/gegevens',
            name: 'Naw',
            component: Naw,
            beforeEnter: ( to, from, next ) =>
            {
                if( !from.name )
                {
                    next( '/' );
                    return;
                }

                next();
            },
            meta: {
                pageType: 'promotion-leadform'
            }
        },
        {
            path: '/bedankt',
            name: 'Thanks',
            component: Thanks,
            beforeEnter: ( to, from, next ) =>
            {
                if( !from.name )
                {
                    next( '/' );
                    return;
                }

                next();
            },
            meta: {
                pageType: 'promotion-confirmation'
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    /* if( to.path !== '/' )
    {
        next( '/' );
        return;
    } */

    if( to.fullPath === '/bedankt' )
    {
        let pageName = '';
        if( store.getters.ABTest === 'A' )
        {
            pageName = 'loten';
        }
        else
        {
            pageName = 'meespelen';
        }

        dataLayer.push({
            event: 'pageview',
            origin: 'website',
            type: to.meta.pageType,
            virtualPage: to.fullPath + '/' + pageName
        });
    }
    else
    {
        dataLayer.push({
            event: 'pageview',
            origin: 'website',
            type: to.meta.pageType,
            virtualPage: to.fullPath
        });
    }

    next();
});

export default appRouter;



// WEBPACK FOOTER //
// ./src/app/router.js